var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSbdFlag(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 45,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#a)",
    fillRule: "evenodd",
    clipRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 44.578 86.783 0H0v44.578Z",
    fill: "#0000D6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90 0 2.39 45H90V0Z",
    fill: "#006000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90 0h-4.825L0 42.662V45h4.825L90 2.426V0Z",
    fill: "#FC0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m6.275.8 1.037 3.032h3.384L7.963 5.687 9.009 8.71 6.275 6.855 3.542 8.72l1.046-3.024-2.734-1.872H5.23L6.275.8Zm16.796 0 1.046 3.032h3.384l-2.742 1.863 1.055 3.024-2.752-1.864-2.724 1.873 1.046-3.024-2.742-1.872h3.383L23.071.8Zm0 12.7 1.046 3.032h3.384l-2.742 1.863 1.055 3.024-2.743-1.872-2.724 1.872 1.046-3.024-2.743-1.872h3.384l1.037-3.023Zm-8.35-6.275 1.047 3.023h3.375l-2.725 1.872 1.037 3.024-2.724-1.873-2.743 1.873 1.055-3.024-2.742-1.872h3.384l1.037-3.023ZM6.276 13.5l1.037 3.032h3.384l-2.733 1.863 1.046 3.024-2.734-1.872-2.733 1.872 1.055-3.024-2.751-1.872H5.22L6.275 13.5Z",
    fill: "#fff"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h60v45H0z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSbdFlag);
export default __webpack_public_path__ + "static/media/sbd-flag.28ae132954edca9bd5dde721a380525c.svg";
export { ForwardRef as ReactComponent };